import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpConfigService } from 'src/app/core/httpConfig/httpConfigService';


@Injectable({
  providedIn: 'root'
})
export class BasicInfoServices {

  api = this.apiConfig.getBaseUrl;
  constructor(
    private apiConfig: HttpConfigService) { }



  /**
   * Get Basic Details
   * @returns 
   */
  getBasicDetails(): Observable<any> {
    return this.apiConfig.get(`${this.api}dashboard/get-started`);
  }



  /**
   * Update Restaurant Name
   * @param name 
   * @returns 
   */
  updateRestaurantName(name: string): Observable<any> {
    return this.apiConfig.patch(this.api + 'account-settings/name/' + name, {
      withCredentials: true,
    });
  }




  /**
   * Update Mobile Number
   * @param name 
   * @returns 
   */
  updateMobileNumber(mobile: number): Observable<any> {
    return this.apiConfig.patch(this.api + 'user/mobile-number/' + mobile, {
      withCredentials: true,
    });
  }

  updateAccountInfo(data: any): Observable<any> {
    return this.apiConfig.put(this.api + 'account-settings', data, {
      withCredentials: true,
    });
  }



  /**
   * Update Email
   * @param emailId 
   * @returns 
   */
  updateEmail(emailId: string): Observable<any> {
    return this.apiConfig.patch(this.api + 'user/email/' + emailId, {
      withCredentials: true,
    });
  }


  
}
